<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.type')"
        :fetchData="fetchLinkedServiceTypes"
        :items="translatedAppointmentTypes"
        type="appointmentType"
        item-text="name"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="3">
      <RealEstateSelectFilter :fetchData="fetchLinkedServiceTypes" />
    </v-col>
  </v-row>
</template>

<script>
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import RealEstateSelectFilter from '@/components/realEstate/RealEstateSelectFilter'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LinkAppointmentTypeChecklistFilters',

  components: { FilterAutocomplete, RealEstateSelectFilter },

  computed: {
    ...mapGetters(['appointmentTypes']),

    translatedAppointmentTypes() {
      return this.appointmentTypes.map(type => {
        const value = typeof type === 'string' ? type : type.value
        return {
          value,
          name: this.$t(`appointment.type.${value}`) || value.replace(/_/g, ' '),
        }
      })
    }
  },

  methods: {
    ...mapActions([
      'fetchAppointmentTypeAsAdmin',
      'fetchLinkedServiceTypes',
    ]),
  },

  async mounted() {
    await this.fetchAppointmentTypeAsAdmin()
  },
}
</script>
